import { Injectable } from '@angular/core';
import { ToasterService, ToasterConfig } from 'angular2-toaster';

@Injectable()
export class ToasterErrorService {

  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      showCloseButton: false,
      tapToDismiss: true,
      positionClass: 'toast-bottom-center',
      timeout: 4000
    });

  constructor(private toasterService: ToasterService) { }

  sendMessage(message: any) {
    const toast = {
      type: 'success',
      title: message
    };
    this.toasterService.pop(toast);
  }

  openToaster(message: string) {
    const toastText = JSON.parse(message);
    const toast = {
      type: 'error',
      title: toastText.detail
    };
    this.toasterService.pop(toast);
  };

  toasterInvalidField() {
    const toast = {
      type: 'error',
      title: 'Field(s) are invalid'
    };
    this.toasterService.pop(toast);
  }

  toasterCredentials(errMsg) {
    const toast = {
      type: 'error',
      title: errMsg || 'Unable to log in with provided credentials'
    };
    this.toasterService.pop(toast);
  }

  toasterRequired() {
    const toast = {
      type: 'error',
      title: 'Fields is required'
    };
    this.toasterService.pop(toast);
  }

  toasterSuccess(data?: string) {
    console.log('Toaster success: ' + data);
    const _title = data ? data : 'Success';
    const toast = {
      type: 'success',
      title: _title
    };
    this.toasterService.pop(toast);
  }

  toasterUnlockInf() {
    const toast = {
      type: 'success',
      title: 'Unlock successful'
    };
    this.toasterService.pop(toast);
  }

  toasterUpdateInf() {
    const toast = {
      type: 'success',
      title: 'Update successful'
    };
    this.toasterService.pop(toast);
  }

  toasterRemoveInf() {
    const toast = {
      type: 'success',
      title: 'Remove success'
    };
    this.toasterService.pop(toast);
  }

  toasterErr(data) {
    console.log('toaster service: ', data);
    const toast = {
      type: 'error',
      title: data,
      timeout: 6000
    };
    this.toasterService.pop(toast);
  }

  toastWarningVehicleFile(title: string, message: string) {
    const toast = {
      type: 'warning',
      title: title,
      body: message,
      showCloseButton: true,
      tapToDismiss: false,
      timeout: 0
    };
    this.toasterService.pop(toast);
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/toaster.service.ts